import { useEffect, useState } from "react";
import { Tag } from "antd";
import { t } from "i18next";
import ApiService from "../../core/service/api-service";
import ResponsiveSelect from "../../core/components/ResponsiveSelect";

/**
 * Çekim listesi seçici (çoklu). Filtre çubuğunda ve gerekirse başka yerlerde kullanılır.
 *
 * Backend zaten YALNIZ görünür listeleri döndürür (§2.1) — burada ayrıca eleme yapılmaz,
 * görünürlük kuralının tek kaynağı sunucudur.
 */
export default function StudyListSelect({ onListLoaded, ...props }) {
    const [lists, setLists] = useState([])

    const getLists = async () => {
        const res = await ApiService.StudyList.GetList();
        if (res.success) {
            setLists(res.data || [])
            onListLoaded && onListLoaded(res.data || [])
        }
    }

    useEffect(() => {
        getLists()
    }, [])

    // label düz metin kalır (arama ve jeton görünümü ondan okur); "Özel" rozeti optionRender ile
    // eklenir — hem açılır listede hem mobil modal seçicide aynı görünür.
    const options = lists.map(x => ({ value: x.id, label: x.name, isPublic: x.isPublic }))

    // antd optionRender'a düzleştirilmiş kaydı verir (asıl nesne `data` altında); modal seçici ise
    // seçeneğin kendisini verir. İkisini de kabul et.
    const renderOption = (option) => {
        const item = option?.data || option;

        return (
            <span>
                <span>{item.label}</span>
                {!item.isPublic && (
                    <Tag style={{ marginLeft: 6 }}>{t('Private')}</Tag>
                )}
            </span>
        );
    }

    return (
        <ResponsiveSelect
            mode={'multiple'}
            allowClear={true}
            optionFilterProp={'label'}
            placeholder={t('Select list')}
            notFoundContent={t('No list yet')}
            options={options}
            optionRender={renderOption}
            {...props}
        />
    )
}
